// Entegrasyonlar sayfası (Platform / Ödeme / SMS sekmeleri) kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'integrations.page';

export const integrationsPageGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'Entegrasyonlar sayfası nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Pazaryeri, yemek sitesi ve kargo bağlantılarınızı, online ödeme sağlayıcılarınızı ve SMS hesabınızı bu sayfadan tanımlarsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  navItems: [
    t(`${G}.nav.platform`, 'Platform Entegrasyonları'),
    t(`${G}.nav.payment`, 'Ödeme Entegrasyonları'),
    t(`${G}.nav.sms`, 'SMS Entegrasyonu'),
  ],
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    tabs: t(`${G}.regions.tabs`, 'Sekmeler'),
    body: t(`${G}.regions.body`, 'Seçili sekmenin içeriği'),
  },
  steps: [
    {
      region: 'tabs',
      title: t(`${G}.s1.title`, '1. Doğru sekmeyi seçin'),
      text: t(`${G}.s1.text`, 'Platform Entegrasyonları: Trendyol, N11, Hepsiburada gibi pazaryerleri, Yemeksepeti, Getir gibi yemek siteleri ve kargo firmaları. Ödeme Entegrasyonları: web sitenizde kartla ödeme alan sağlayıcılar. SMS Entegrasyonu: müşterilere SMS göndermek için kullanılan hesap.'),
      tips: [
        t(`${G}.s1.tip1`, 'Seçtiğiniz sekme adres çubuğuna yazılır (ör. ?tab=payment); bu bağlantıyı kaydederseniz sayfa doğrudan o sekmeyle açılır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Platform bağlayın'),
      text: t(`${G}.s2.text`, 'Platform Entegrasyonları sekmesinde "Pazaryeri Entegrasyonu Ekle", "Yemek Entegrasyonu Ekle" veya "Kargo Entegrasyonu Ekle" ile platformun size verdiği API bilgilerini girersiniz. Bağlantılar türlerine göre üç ayrı tabloda listelenir. Bu sekmenin ayrıntıları sekmedeki kendi (i) rehberindedir.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Ödeme sağlayıcısını tanımlayın'),
      text: t(`${G}.s3.text`, 'Ödeme Entegrasyonları sekmesinde "Ödeme Entegrasyonu Ekle" ile web sitenizde kartla ödeme almak için sağlayıcınızın mağaza bilgilerini (Merchant ID vb.) girersiniz. Listede her kaydın Aktif / Pasif durumu, test modundaysa "Test", 3D Secure açıksa "3D" etiketi ve bağlı şubesi görünür. Satırın ⋮ menüsünde Düzenle ve Sil bulunur.'),
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. SMS hesabını bağlayın'),
      text: t(`${G}.s4.text`, 'SMS Entegrasyonu sekmesinde firmanıza ait Öztek hesabının Müşteri no (Kno), Kullanıcı adı, Şifre ve Gönderen başlık bilgilerini girip "Kaydet"e basın. Aktif kayıt, tahsilat makbuzu ve ödeme linki SMS\'lerinde kullanılır; şifre veritabanında şifreli saklanır.'),
    },
    {
      region: 'header',
      title: t(`${G}.s5.title`, '5. Bağlantıyı test edin'),
      text: t(`${G}.s5.text`, 'Her yeni bağlantıdan sonra test yapın: platformlarda satırın ⋮ menüsündeki "Bağlantıyı Test Et", SMS Entegrasyonu sekmesinde ayarları kaydettikten sonra "Test SMS gönder" ile kendi numaranıza deneme mesajı. Test başarısızsa girdiğiniz anahtarları platform panelinden yeniden kontrol edin. Başlıktaki (i) bu rehberi yeniden açar.'),
    },
  ],
});
